import { Typography, Box, ButtonGroup, Button, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper, Icon, IconButton, Tooltip, Divider, Snackbar, CircularProgress, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { RejectionDialog, SendMailDialog } from 'components'
import ConfirmDialog from 'components/ConfirmDialog/ConfirmDialog'
import ApproveDocumentDialog from 'components/ApproveDocumentDialog/ApproveDocumentDialog'
import { AuthContext, DocumentContext } from 'context'
import FileSaver from 'file-saver'
import { DASHBOARD_PATH, DOCUMENT_ACTIONS, DOCUMENT_PATH, DOCUMENT_STATES, getDocumentActions, approveDocumentService, downloadPdfByDocumentFileId, assignPurchaseOrderService, DOCUMENT_TYPE_CODES, rejectDocumentService, DOCUMENT_TYPE_IDS, DOCUMENT_MANAGE_ACTION_ID, updateDocumentStatusService, ADDITIONAL_CREDIT_NOTE_DOCUMENT_ACTIONS, DOCUMENT_APPROVE_MANUALLY_ACTION_ID, DOCUMENT_REJECT_MANUALLY_ACTION_ID, DOCUMENT_SEND_REIMBURSEMENT_ACTION_ID, reinciarComprobanteWS } from 'lib'
import React from 'react'
import { useHistory } from 'react-router-dom'
import { IDocument, IDocumentAction, IDocumentAdditionalInfo, IDocumentHeader, IMessageConfig, IPurchaseOrderAccoutingInfo, IRejectionCause, ITaxPlan } from 'types'
import { wsFinalizeInvoiceEmitedManually } from 'api/APIBajoDemanda'
import { wsObtenerIDAprobador, wsReenviarCorreoAprobador } from 'api/APIDraft'
import { RUC_EMPRESA } from 'constants/constants'
import ResetDocumentStatusDialog from './ResetDocumentStatusDialog'

interface Props {
    processStatus: number
    documentType?: string
    supplierId?: number
    documentId?: number
    documentData: any
    onReload: () => void
    isManual?: boolean
    header: IDocumentHeader
    documentTypeId: number
    redirectOnApprove?: string
    redirectOnReject?: string
    aditionalInfo: any
    validateReimbusements?: boolean
    companyruc?: string
    invoiceAso?: string
    invoiceDate?: string
    invoiceId?: number
    pu: String[]
    document: IDocument
}

const DocumentBar = (props: Props) => {
    const { processStatus, documentType, supplierId, documentId, documentData,
        onReload, isManual, header, documentTypeId, redirectOnApprove, aditionalInfo,
        validateReimbusements, redirectOnReject, companyruc, invoiceAso, invoiceDate, invoiceId, pu, document } = props
    const history = useHistory()
    const { conditions, refreshConditions, documentTypes } = React.useContext(DocumentContext)
    const { user } = React.useContext(AuthContext)
    const [open, setOpen] = React.useState(false)
    const anchorRef = React.useRef<HTMLDivElement>(null)
    const [selected, setSelected] = React.useState<IDocumentAction | undefined>(undefined)
    const [openRejectionDialog, setOpenRejectionDialog] = React.useState(false)
    const [openApproval, setOpenApprovalDialog] = React.useState(false)
    const [openPending, setOpenPending] = React.useState(false)
    const [openSend, setOpenSend] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [messageConfig, setMessageConfig] = React.useState<IMessageConfig>({ open: false, message: "", severity: "info" })

    const [openFinalizeInvoice, setOpenFinalizeInvoice] = React.useState(false);

    const [openResetStatusDialog, setOpenResetStatusDialog] = React.useState(false)

    const handleClickOpenFinalizeInvoice = () => {
        setOpenFinalizeInvoice(true);
    };
    const handleClickCloseFinalizeInvoice = () => {
        setOpenFinalizeInvoice(false);
    };
    const handleFinalizeInvoice = () => {
        wsFinalizeInvoiceEmitedManually(documentId!);
        setOpenFinalizeInvoice(false);
        history.goBack()
    };

    const getCorrectAprobeName = (selectedName: string) => {
        const isInvoiceEmited = selectedName === 'Aprobar' && companyruc === RUC_EMPRESA && documentTypeId === DOCUMENT_TYPE_IDS.electronicInvoice
        return isInvoiceEmited ? 'Finalizar' : selectedName
    }


    const handleClick = () => {
        if (!selected) {
            setMessageConfig({ open: true, message: "Selecciona una acción", severity: "warning" })
            return
        }
        if (selected?.key === "canChangeStatus") {
            setOpenResetStatusDialog(true)
            return
        }
        if (selected?.id === DOCUMENT_ACTIONS.reject.id) {
            setOpenRejectionDialog(true)
            return
        }
        if (selected?.id === ADDITIONAL_CREDIT_NOTE_DOCUMENT_ACTIONS.ignore.id) {
            handleIgnore()
            return
        }
        if (selected?.id === DOCUMENT_ACTIONS.approve.id && documentTypeId === DOCUMENT_TYPE_IDS.electronicInvoice && companyruc == RUC_EMPRESA) {
            handleClickOpenFinalizeInvoice()
            return
        }
        if (selected?.id === DOCUMENT_ACTIONS.approve.id && (
            documentTypeId === DOCUMENT_TYPE_IDS.cashReimbursement || documentTypeId === DOCUMENT_TYPE_IDS.employeeReimbursement
            || documentTypeId === DOCUMENT_TYPE_IDS.creditNote || documentTypeId === DOCUMENT_TYPE_IDS.printedCreditNote)) {
            handleDirectApprove()
            return
        }
        if (selected?.id === DOCUMENT_ACTIONS.approve.id) {
            if (validateReimbusements !== undefined && !validateReimbusements) {
                setMessageConfig({ open: true, message: "Los valores enviados a COUPA y datos de las facturas de sustento no coiciden", severity: "error" })
                return
            }
            setOpenApprovalDialog(true)
        }
        if (selected?.id === DOCUMENT_MANAGE_ACTION_ID
            || selected?.id === DOCUMENT_APPROVE_MANUALLY_ACTION_ID
            || selected?.id === DOCUMENT_REJECT_MANUALLY_ACTION_ID
            || selected?.id === DOCUMENT_SEND_REIMBURSEMENT_ACTION_ID) {
            setOpenSend(true)
        }
    }

    const handleIgnore = async () => {
        try {
            setLoading(true)
            await updateDocumentStatusService(documentId, ADDITIONAL_CREDIT_NOTE_DOCUMENT_ACTIONS.ignore.id, user?.userId)
            setMessageConfig({ open: true, message: "El documento se ha cambiado de estado!", severity: "success" })
            onReload()
            setLoading(false)
            if (redirectOnApprove) {
                setTimeout(() => { history.replace(redirectOnApprove) }, 1500)
            }
        } catch (error) {
            setLoading(false)
            setMessageConfig({ open: true, message: "No se pudo cambiar el estado del documento...", severity: "error" })
        }
    }

    const handleResetDocumentStatus = async () => {
        try {
            setLoading(true)

            await reinciarComprobanteWS(
                documentId,
                user?.userId
            )

            setMessageConfig({
                open: true,
                message: "El estado del comprobante fue reiniciado!",
                severity: "success"
            })

            setOpenResetStatusDialog(false)
            history.goBack()
            onReload()

        } catch (error) {

            setMessageConfig({
                open: true,
                message: "No se pudo reiniciar el estado del comprobante...",
                severity: "error"
            })

        } finally {
            setLoading(false)
        }
    }

    const handleMenuItemClick = (event: React.MouseEvent<HTMLLIElement, MouseEvent>, action: IDocumentAction) => {
        if (action.id === DOCUMENT_MANAGE_ACTION_ID
            || action.id === DOCUMENT_APPROVE_MANUALLY_ACTION_ID
            || action.id === DOCUMENT_REJECT_MANUALLY_ACTION_ID
            || action.id === DOCUMENT_SEND_REIMBURSEMENT_ACTION_ID) {
            setSelected(action)
            setOpenSend(true)
        } else {
            setSelected(action)
        }
        setOpen(false)
    }

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen)
    }

    const handleClose = (event: React.MouseEvent<Document, MouseEvent>) => {
        if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
            return
        }
        setOpen(false)
    }

    const handleDownload = async () => {
        try {
            setLoading(true)
            const result = await downloadPdfByDocumentFileId(documentId)
            FileSaver.saveAs(result, `${documentType}_${documentId}.pdf`)
            setMessageConfig({ open: true, message: "Su descarga ha comenzado", severity: "info" })
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }

    const handleDirectApprove = async () => {
        try {
            setLoading(true)
            await approveDocumentService(
                {
                    documentId,
                    userId: user?.userId,
                    statusId: DOCUMENT_STATES.authorized
                },
                isManual ?
                    { ...documentData, } :
                    { documentData: {} }
            )
            setMessageConfig({ open: true, message: "Documento aprobado!", severity: "success" })
            onReload()
            setLoading(false)
            if (redirectOnApprove) {
                setTimeout(() => { history.replace(redirectOnApprove) }, 1500)
            }
        } catch (error) {
            setMessageConfig({ open: true, message: "No se pudo aprobar el documento...", severity: "error" })
            setLoading(false)
        }
    }

    const handleApprove = async (taxPlan?: ITaxPlan, purchaseOrder?: IPurchaseOrderAccoutingInfo) => {
        try {
            setLoading(true)
            await approveDocumentService(
                {
                    documentId,
                    userId: user?.userId,
                    statusId: DOCUMENT_STATES.authorized
                },
                isManual ?
                    {
                        ...documentData,
                        taxPlan,
                        accountInfo: { ...documentData.accountInfo, purchaseOrder },
                    } :
                    {
                        documentData: {},
                        taxPlan,
                        accountInfo: { ...documentData.accountInfo, purchaseOrder },
                        reimbursements: documentTypeId === DOCUMENT_TYPE_IDS.reimbursementInvoice ? JSON.parse(aditionalInfo).reimbursements : documentData.reimbursements
                    }
            )
            if (purchaseOrder?.documentId) {
                await assignPurchaseOrderService(purchaseOrder?.documentId, user?.userId, documentId)
            }
            setMessageConfig({ open: true, message: "Documento aprobado!", severity: "success" })
            onReload()
            setLoading(false)
            if (redirectOnApprove) {
                setTimeout(() => { history.replace(redirectOnApprove) }, 1500)
            }
        } catch (error) {
            setMessageConfig({ open: true, message: "No se pudo aprobar el documento...", severity: "error" })
            setLoading(false)
        }
    }
    const getRejectionCause = (rejectionCause: IRejectionCause | string) => {
        if (typeof rejectionCause === 'string') {
            const causa: IRejectionCause = {
                rejectionCauseId: 0,
                rejectionCauseCode: 0,
                name: rejectionCause,
                description: rejectionCause,
                active: true
            }
            return causa
        }
        return rejectionCause as IRejectionCause
    }

    const handleReject = async (rejectionCause: IRejectionCause | string) => {

        try {
            setLoading(true)
            const cause = getRejectionCause(rejectionCause)
            const documentDataTexto = isManual ?
                {
                    ...documentData,
                    rejectionCause: cause
                } : {
                    ...JSON.parse(aditionalInfo),
                    rejectionCause: cause
                }
            await rejectDocumentService(
                {
                    documentId,
                    userId: user?.userId,
                    statusId: DOCUMENT_STATES.rejected
                },
                documentDataTexto
            )
            setMessageConfig({ open: true, message: "Documento rechazado!", severity: "success" })
            onReload()
            setLoading(false)
            if (redirectOnReject) {
                setTimeout(() => { history.replace(redirectOnReject) }, 1500)
            }
        } catch (error) {
            setMessageConfig({ open: true, message: "No se pudo aprobar el documento...", severity: "error" })
            setLoading(false)
        }
    }

    React.useEffect(() => {
        refreshConditions()
    }, [refreshConditions])


    // SECCION REEMBOLSOS CON APROBADOR
    const [idAprobadro, setidAprobadro] = React.useState<number | undefined>(undefined)
    React.useEffect(() => {
        getIDAprobador(documentId!)
    }, [])

    const getIDAprobador = async (id: number) => {
        try {
            setLoading(true)
            const idaprobador = await wsObtenerIDAprobador(id)
            setidAprobadro(idaprobador)
            setLoading(false)
        } catch (error) {
            setLoading(false)
            setMessageConfig({ open: true, message: "Ocurrio un error en el proceso", severity: "error" })
        }
    }

    return (
        <div className="flex py-3 pr-8 items-center pl-4">
            <div className="flex flex-grow items-center">
                <Tooltip arrow title="Regresar">
                    <IconButton
                        onClick={() => history.action !== "POP" ? history.goBack() : history.push(`${DOCUMENT_PATH}${DASHBOARD_PATH}`)}
                    >
                        <Icon fontSize="small">
                            chevron_left
                        </Icon>
                    </IconButton>
                </Tooltip>
                <div className="ml-3 mr-6" style={{ height: 20 }}>
                    <Divider orientation="vertical" />
                </div>
                <Icon fontSize="small" color="action">
                    {"check"}
                </Icon>
                <div className="flex flex-col pl-4">
                    <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600, letterSpacing: 0.5 }}>
                        {documentType ?? ""}
                    </Typography>
                    <Box color="info.main">
                        <Typography variant="caption" style={{ fontWeight: 600, letterSpacing: 0.5, fontSize: "0.7em" }}>
                            {conditions.find(c => c.conditionId === processStatus)?.name}
                        </Typography>
                    </Box>
                </div>
            </div>
            <div className="flex items-center">
                <Button
                    disabled={loading}
                    size="small"
                    onClick={handleDownload}
                    style={{ marginRight: 15 }}
                    color="primary"
                    disableElevation
                    variant="contained"
                >
                    {"Descargar pdf"}
                </Button>
                {
                    (processStatus == DOCUMENT_STATES.pending || processStatus == DOCUMENT_STATES.rejected) && document.receiverRuc == '1891744672001' && (document.documentTypeId == 1 || document.documentTypeId == 8) &&
                    <ButtonGroup disableElevation size="small" variant="contained" color={selected ? "primary" : "default"} ref={anchorRef} aria-label="split button" >
                        <Button
                            style={{ width: 180 }}
                            onClick={() => handleClick()}
                            disabled={loading}
                        >
                            {loading ? <CircularProgress color="primary" size={15} thickness={10} /> : selected ? getCorrectAprobeName(selected.name) : conditions.find(c => c.conditionId === processStatus)?.name ?? ""}
                        </Button>
                        {
                            <Button
                                disabled={loading}
                                size="small"

                                onClick={handleToggle}
                            >
                                <Icon fontSize="small">arrow_drop_down</Icon>
                            </Button>
                        }
                    </ButtonGroup>
                }

                <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
                    {({ TransitionProps, placement }) => (
                        <Grow {...TransitionProps} style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}>
                            <Paper style={{ width: 220 }}>
                                <ClickAwayListener onClickAway={handleClose}>
                                    <MenuList dense id="split-button-menu">
                                        {documentTypeId !== DOCUMENT_TYPE_IDS.employeeReimbursement &&
                                            [
                                                ...getDocumentActions(documentTypeId),
                                            ]
                                                .filter(option => {

                                                    // Si el flowStatus es 4, solo mostrar "Cambiar de estado"
                                                    if (document.flowStatus === 4) {
                                                        return option.name === "Cambiar de estado";
                                                    }

                                                    // Ocultar "Cambiar de estado" si flowStatus no es 4
                                                    if (option.name === "Cambiar de estado") {
                                                        return false;
                                                    }

                                                    // Ocultar "Aprobar" si document.error tiene el texto específico
                                                    if (
                                                        option.name === "Aprobar" &&
                                                        (document.error?.includes("tiene mas de un plan de impuestos"))
                                                    ) {
                                                        return true;
                                                    }

                                                    // Mostrar todo lo que no sea "Aprobar"
                                                    if (option.name !== "Aprobar") {
                                                        return true;
                                                    }

                                                    return false;
                                                })
                                                .map((option) => {

                                                    const itemName =
                                                        option.name === 'Aprobar' &&
                                                            companyruc === RUC_EMPRESA &&
                                                            documentTypeId === DOCUMENT_TYPE_IDS.electronicInvoice
                                                            ? 'Finalizar'
                                                            : option.name;

                                                    return (
                                                        <MenuItem
                                                            dense
                                                            key={option.name}
                                                            onClick={(event) => handleMenuItemClick(event, option)}
                                                            classes={{ root: "button-list-menu-item" }}
                                                            selected={option.id === selected?.id}
                                                            style={{ padding: 0 }}
                                                        >
                                                            <div className="flex items-center h-full w-full py-1 pr-2 pl-1">
                                                                <Typography
                                                                    className="flex-grow pl-2"
                                                                    variant="caption"
                                                                    style={{ letterSpacing: 0.2 }}
                                                                >
                                                                    {itemName}
                                                                </Typography>
                                                                <Icon color="inherit" fontSize="small">
                                                                    {option.icon}
                                                                </Icon>
                                                            </div>
                                                        </MenuItem>
                                                    );
                                                })}
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </div>
            <ApproveDocumentDialog
                open={openApproval}
                onClose={() => setOpenApprovalDialog(false)}
                onApprove={handleApprove}
                supplierId={supplierId}
                requirePo={document.error?.includes("No se encontró orden de compra con") ?? false}
                requireTaxPlan={document.error?.includes("tiene mas de un plan de impuestos") ?? false}
                identification={document.companyRuc}
                purchaseOrder={documentData.accountInfo?.purchaseOrder}
                withReimbursementTaxPlan={Boolean(documentTypes.find(d => d.documentCode === DOCUMENT_TYPE_CODES.reimbursementInvoice)?.documentTypeId === documentTypeId)}
                puObservation={pu}
                document={document}
            />
            <RejectionDialog
                open={openRejectionDialog}
                onClose={() => setOpenRejectionDialog(false)}
                onReject={handleReject}
                freesolo={documentTypeId === DOCUMENT_TYPE_IDS.employeeReimbursement || documentTypeId === DOCUMENT_TYPE_IDS.cashReimbursement}
            />
            <ConfirmDialog
                open={openPending}
                onCancel={() => setOpenPending(false)}
                onConfirm={async () => true}
                title={"¿Estas seguro de dejar pendiente este documento?"}
            />
            <Snackbar open={messageConfig.open} autoHideDuration={6000} onClose={() => setMessageConfig({ ...messageConfig, open: false })} anchorOrigin={{ horizontal: "right", vertical: "bottom" }}>
                <Alert variant="filled" onClose={() => setMessageConfig({ ...messageConfig, open: false })} severity={messageConfig.severity}>
                    {messageConfig.message}
                </Alert>
            </Snackbar>
            <SendMailDialog
                open={openSend}
                onClose={() => setOpenSend(false)}
                supplier={header.supplier}
                onSend={() => setMessageConfig({ severity: 'success', message: "Correo enviado!", open: true })}
                onError={() => setMessageConfig({ severity: 'error', message: "No se pudo enviar el correo...", open: true })}
                noEmailsMessage={() => setMessageConfig({ severity: 'warning', message: "Agregar al menos un destinatario para continuar", open: true })}
                invoiceNumber={header.invoiceNumber}
                aditionalInfo={aditionalInfo}
                documentId={documentId ?? -1}
                selectedAction={selected}
                documentData={documentData}
                isManual={isManual}
                factserial={invoiceAso}
                factdate={invoiceDate}
                factid={invoiceId}
            />
            <Dialog
                style={{ padding: '40px' }}
                open={openFinalizeInvoice}
                onClose={handleClickCloseFinalizeInvoice}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" style={{ padding: '20px', color: 'black' }}>
                        ¿Esta seguro de finalizar la factura?
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ padding: '20px' }}>
                    <Button onClick={handleClickCloseFinalizeInvoice}>Cancelar</Button>
                    <Button variant='contained' color='primary' onClick={handleFinalizeInvoice} autoFocus>Aceptar</Button>
                </DialogActions>
            </Dialog>
            <ResetDocumentStatusDialog
                open={openResetStatusDialog}
                onClose={() => setOpenResetStatusDialog(false)}
                onConfirm={handleResetDocumentStatus}
            />
        </div>
    )
}

export default DocumentBar
